/* An implementation of a multiset.
 * Heavily modified from the npm package cell-multiset.
*/
var MultiSet = /** @class */ (function () {
    function MultiSet(elms) {
        var _this = this;
        this.elements = new Map();
        if (elms) {
            elms.forEach(function (elm) { return _this.add(elm); });
        }
        return this;
    }
    MultiSet.prototype.add = function () {
        var elms = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elms[_i] = arguments[_i];
        }
        return this.addCollection(elms);
    };
    MultiSet.prototype.addCollection = function (elms) {
        var _this = this;
        elms.forEach(function (elm) {
            _this.elements.set(elm, (_this.elements.get(elm) || 0) + 1);
        });
        return this;
    };
    Object.defineProperty(MultiSet.prototype, "cardinality", {
        get: function () {
            var len = 0;
            this.elements.forEach(function (multiplicity) { return (len += multiplicity); });
            return len;
        },
        enumerable: true,
        configurable: true
    });
    MultiSet.prototype.clear = function () {
        this.elements.clear();
        return this;
    };
    MultiSet.prototype.contains = function (multiset) {
        var _this = this;
        var found = true;
        multiset.elements.forEach(function (multiplicity, elm) {
            if (multiplicity > _this.multiplicity(elm)) {
                found = false;
            }
        });
        return found;
    };
    MultiSet.prototype.difference = function (multiset) {
        var _this = this;
        this.elements.forEach(function (multiplicity, elm) {
            var nmul = multiplicity - multiset.multiplicity(elm);
            if (nmul <= 0) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, nmul);
            }
        });
        return this;
    };
    MultiSet.prototype.Difference = function (multiset) {
        var output = new MultiSet();
        this.elements.forEach(function (multiplicity, elm) {
            var nmul = multiplicity - multiset.multiplicity(elm);
            if (nmul > 0) {
                output.elements.set(elm, nmul);
            }
        });
        return output;
    };
    MultiSet.prototype.each = function (callback, ctx) {
        var _this = this;
        var all = true;
        this.elements.forEach(function (mul, elm) {
            if (callback.call(ctx, elm, mul, _this) === false) {
                all = false;
            }
        });
        return all;
    };
    MultiSet.prototype.entries = function () {
        return this.elements.entries();
    };
    MultiSet.prototype.equals = function (multiset) {
        var _this = this;
        return multiset.each(function (mul, elm) { return mul !== _this.multiplicity(elm); });
    };
    MultiSet.prototype.has = function (elm) {
        return !!this.elements.get(elm);
    };
    MultiSet.prototype.isEmpty = function () {
        return !!this.elements.size;
    };
    MultiSet.prototype.intersection = function (multiset) {
        var _this = this;
        var nmul;
        this.elements.forEach(function (multiplicity, elm) {
            nmul = Math.min(multiplicity, multiset.multiplicity(elm));
            if (!nmul) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, nmul);
            }
        });
        return this;
    };
    MultiSet.prototype.Intersection = function (multiset) {
        var output = new MultiSet();
        var nmul;
        this.elements.forEach(function (multiplicity, elm) {
            nmul = Math.min(multiplicity, multiset.multiplicity(elm));
            if (nmul) {
                output.elements.set(elm, nmul);
            }
        });
        return output;
    };
    MultiSet.prototype.isSubsetOf = function (multiset) {
        return multiset.contains(this);
    };
    MultiSet.prototype.keys = function () {
        return this.elements.keys();
    };
    MultiSet.prototype.multiplicity = function (elm) {
        return this.elements.get(elm) || 0;
    };
    MultiSet.prototype.remove = function () {
        var elms = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elms[_i] = arguments[_i];
        }
        return this.removeCollection(elms);
    };
    MultiSet.prototype.removeCollection = function (elms) {
        var _this = this;
        elms.forEach(function (elm) {
            var multiplicity = _this.elements.get(elm) || 0;
            if (multiplicity === 1) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, Math.max(0, multiplicity - 1));
            }
        });
        return this;
    };
    MultiSet.prototype.symmetricDifference = function (multiset) {
        var _this = this;
        multiset.elements.forEach(function (multiplicity, elm) {
            var diff = _this.multiplicity(elm) - multiplicity;
            if (!diff) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, Math.abs(diff));
            }
        });
        return this;
    };
    MultiSet.prototype.union = function (multiset) {
        var _this = this;
        multiset.elements.forEach(function (multiplicity, elm) {
            return _this.elements.set(elm, Math.max(multiplicity, _this.multiplicity(elm)));
        });
        return this;
    };
    MultiSet.prototype.values = function () {
        return Array.from(this.elements.keys());
    };
    return MultiSet;
}());
export { MultiSet };



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/websocket/multiset.ts.pre-build-optimizer.js